// src/pages/personalizados/publicPersonalized.service.js
import { djangoApi } from "../../utils/axios/axios.utils";

export async function getPublicSellerBySid(sid) {
    const cleanSid = String(sid || "").trim();

    if (!cleanSid) {
        return {
            ok: false,
            status: 400,
            message: "sid não informado.",
            data: null,
        };
    }

    try {
        const res = await djangoApi.get(`sellers/sellers/public-catalog-seller/`, {
            params: {
                sid: cleanSid,
            },
        });

        return {
            ok: true,
            status: res.status,
            message: res?.data?.message || "Revendedora localizada.",
            data: res?.data?.data || null,
        };
    } catch (error) {
        console.log("Erro ao buscar Revendedora pública:", error);

        return {
            ok: false,
            status: error?.response?.status || 500,
            message:
                error?.response?.data?.message || "Erro ao consultar Revendedora.",
            data: null,
        };
    }
}


export async function createPublicPersonalizedOrder(payload) {
    try {
        const res = await djangoApi.post(
            `products/catalog/public-orders/`,
            payload
        );

        return {
            ok: true,
            status: res.status,
            message: res?.data?.message || "Pedido enviado com sucesso.",
            data: res?.data?.data || null,
        };
    } catch (error) {
        console.log("Erro ao salvar pedido personalizado:", error);

        return {
            ok: false,
            status: error?.response?.status || 500,
            message:
                error?.response?.data?.message || "Erro ao salvar pedido.",
            data: error?.response?.data?.data || null,
            errors: error?.response?.data || null,
        };
    }
}


function toNumber(value) {
    const n = Number(value || 0);
    return Number.isFinite(n) ? n : 0;
}

function normalizeFrontendConfig(frontendConfig) {
    const cfg = frontendConfig || {};

    return {
        text_inputs: Array.isArray(cfg.text_inputs) ? cfg.text_inputs : [],
        options: Array.isArray(cfg.options) ? cfg.options : [],
        allow_photo: Boolean(cfg.allow_photo),
    };
}

const PRODUCT_TYPE_DICT = {
    PG: "Pingente",
    C: "Corrente",
    PU: "Pulseira",
};

function normalizeProductType(value) {
    const raw = String(value || "").trim().toUpperCase();
    return PRODUCT_TYPE_DICT[raw] || value || "Padrão";
}

function mapApiRowToVariant(row) {
    const productTypeCode = String(row.product_type || "").trim().toUpperCase();

    return {
        id: row.id,
        option_id: row.pitaya_code,
        code: row.pitaya_code,
        color: row.color || "",
        product_type_code: productTypeCode || "",
        product_type: normalizeProductType(row.product_type),
        size: row.size || "",
        price: toNumber(row.sale_price),
        thumb_image: row.option_image_url || null,

        // compatibilidade temporária com código antigo
        chain_type: normalizeProductType(row.product_type),

        raw: row,
    };
}

function buildCatalogProducts(apiRows = []) {
    const grouped = new Map();

    apiRows.forEach((row) => {
        const groupKey = String(row.group_code || row.pitaya_code || row.id);

        if (!grouped.has(groupKey)) {
            const cfg = normalizeFrontendConfig(row.frontend_config);

            grouped.set(groupKey, {
                id: groupKey,
                group_code: row.group_code || null,
                name: row.name || row.pitaya_code,
                description: row.description || "",
                card_image: row.image_url || null,
                base_price: toNumber(row.sale_price),
                frontend_config: cfg,
                text_config: {
                    enabled: cfg.text_inputs.length > 0,
                    inputs: cfg.text_inputs,
                },
                extra_options: cfg.options,
                allow_photo: cfg.allow_photo,
                ordering: toNumber(row.ordering),
                options: [],
            });
        }

        const product = grouped.get(groupKey);

        product.options.push(mapApiRowToVariant(row));

        if (!product.base_price || toNumber(row.sale_price) < product.base_price) {
            product.base_price = toNumber(row.sale_price);
        }

        const rowOrdering = toNumber(row.ordering);
        if (!product.ordering || rowOrdering < product.ordering) {
            product.ordering = rowOrdering;
        }
    });

    return Array.from(grouped.values()).sort((a, b) => {
        const aOrder = toNumber(a.ordering);
        const bOrder = toNumber(b.ordering);

        if (aOrder !== bOrder) return aOrder - bOrder;

        return String(a.group_code || a.id || "").localeCompare(
            String(b.group_code || b.id || "")
        );
    });
}

export async function getPublicPersonalizedCatalogProducts() {
    try {
        const res = await djangoApi.get("products/public/personalized-catalog-products/");
        console.log("ressss", res);

        const raw = Array.isArray(res?.data)
            ? res.data
            : Array.isArray(res?.data?.results)
                ? res.data.results
                : [];

        return {
            ok: true,
            status: res.status,
            data: buildCatalogProducts(raw),
            raw,
        };
    } catch (error) {
        console.log("Erro ao buscar catálogo personalizado:", error);

        return {
            ok: false,
            status: error?.response?.status || 500,
            data: [],
            raw: [],
        };
    }
}